/**
 * Calendário Econômico (migrada do Streamlit; equivalência em
 * backend/tests_paginas/test_calendario.py).
 *
 * Eventos da próxima semana do TradingView para Estados Unidos e Brasil; linhas de
 * importância alta em destaque. Sem filtros. O backend guarda a consulta por 4 h e, se
 * o TradingView falhar, mostra a última consulta boa com aviso.
 */
import { Alert, Loader, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { CabecalhoPagina, Pagina, Secao } from '../../components/Layout';
import { ErroApi, apiGet, type Envelope } from '../../api/cliente';
import { AvisosApi } from '../../components/AvisosApi';
import { TabelaDados, type TabelaApi } from '../../components/TabelaDados';
import { formatarDataHora } from '../../lib/formatos';
interface DadosCalendario {
  secoes: { titulo: string; tabela: TabelaApi }[];
  atualizado_em: string;
}
export function CalendarioEconomico() {
  const consulta = useQuery({
    queryKey: ['utilitarios.calendario'],
    queryFn: ({ signal }) =>
      apiGet<Envelope<DadosCalendario>>('/utilitarios/calendario-economico', {}, signal),
  });
  const dados = consulta.data?.data;
  return (
    <Pagina>
      <CabecalhoPagina
        titulo="Calendário Econômico"
        descricao="Eventos econômicos da próxima semana nos Estados Unidos e no Brasil; os de importância alta ficam em destaque."
        fonte="TradingView"
      >
        {dados && (
          <Text size="xs" c="dimmed">
            Atualizado em {formatarDataHora(dados.atualizado_em)}
          </Text>
        )}
      </CabecalhoPagina>
      {consulta.isPending && <Loader />}
      {consulta.isError && (
        <Alert color="red">
          {consulta.error instanceof ErroApi
            ? consulta.error.message
            : 'Não foi possível carregar o calendário.'}
        </Alert>
      )}
      {dados && (
        <>
          <AvisosApi avisos={[consulta.data?.meta.avisos]} />
          {dados.secoes.map((secao) => (
            <Secao key={secao.titulo} titulo={secao.titulo}>
              {secao.tabela.linhas.length > 0 ? (
                <TabelaDados tabela={secao.tabela} alturaAutomatica />
              ) : (
                <Text size="sm" c="dimmed">
                  Nenhum evento na semana.
                </Text>
              )}
            </Secao>
          ))}
        </>
      )}
    </Pagina>
  );
}
